import { makeStyles } from 'tss-react/mui';
import { getColors, typography } from '../tokens';

export type StatusLevel = 'healthy' | 'degraded' | 'critical' | 'unknown';

const STATUS_DEFAULT_LABELS: Record<StatusLevel, string> = {
  healthy: 'Operational',
  degraded: 'Degraded',
  critical: 'Critical',
  unknown: 'Unknown',
};

const useStyles = makeStyles<{ status: StatusLevel }>()((theme, { status }) => {
  const c = getColors(theme.palette.mode);
  const color = c.status[status];
  return {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '4px 10px',
      borderRadius: 20,
      backgroundColor: `${color}26`,
      fontSize: 12,
      fontWeight: 500,
      fontFamily: typography.fontFamilyCorpoSText,
      lineHeight: 1.3,
      whiteSpace: 'nowrap' as const,
    },
    dot: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: color,
      flexShrink: 0,
    },
    label: {
      color,
    },
  };
});

export interface StatusBadgeProps {
  status: StatusLevel;
  label?: string;
}

export const StatusBadge = ({ status, label }: Readonly<StatusBadgeProps>) => {
  const { classes } = useStyles({ status });
  const displayLabel = label ?? STATUS_DEFAULT_LABELS[status];

  return (
    <span className={classes.root}>
      <span className={classes.dot} />
      <span className={classes.label}>{displayLabel}</span>
    </span>
  );
};
